import {getSerializedPagewebError} from '../../../errors/getSerializedPagewebError.function';
import {AgeAuthQueryVariables} from '../../../graphql/generated/types';
import {useAgeAuthQuery} from '../../../wrapper/userWrapper';

interface useFetchAgeAuthParam {
  fetchAgeAuthVariables: AgeAuthQueryVariables;
}

export function useFetchAgeAuth({fetchAgeAuthVariables}: useFetchAgeAuthParam) {
  const {
    data,
    error,
    isFetching: fetching,
  } = useAgeAuthQuery(fetchAgeAuthVariables);

  return {
    isLoading: fetching,
    data,
    error: error ? getSerializedPagewebError(error) : undefined,
  };
}
